import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { NavigationEnd, Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
path;

  constructor(public db:DataService , private router:Router) { }

  IsLoggedIn(){
    return localStorage.getItem('domain_api_secret')
  }

  get_path(){
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.path = event.url;
        this.db.path = event.url;      
        let url = this.db.path.split('/login')
        console.log(this.path)  
        if(this.IsLoggedIn() && this.path == '/login') {
          this.router.navigate(['/admin-dashboard'])
          // this.db.tabs = true;
        }               
        // if(this.path == '/' || this.path == '/register' || url[1] == 'p' || this.path == '/contact-us'){
           
        // }
      }
    });
  }
}
